import type { FC, ReactNode } from 'react'
import React from 'react'
import type { DialogProps } from '@material-ui/core/Dialog'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import clsx from 'clsx'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      '& .MuiDialogActions-root': {
        '& button:first-child': {
          marginRight: 6,
        },
      },
    },
  }),
)

interface IProps extends DialogProps {
  className?: string
  open: boolean
  dialogHeading?: ReactNode
  dialogContent?: ReactNode
  dialogActions?: ReactNode
}

const CustomSnackbar: FC<IProps> = ({
  className,
  open,
  dialogActions,
  dialogHeading,
  dialogContent,
  ...rest
}) => {
  const classes = useStyles()

  return (
    <Dialog
      className={clsx(classes.root, className && className)}
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      {...rest}
    >
      <DialogTitle id="alert-dialog-title">
        {!!dialogHeading && dialogHeading}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {!!dialogContent && dialogContent}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {/* <Button onClick={handleClose} color="primary">
          Disagree
        </Button>
        <Button onClick={handleClose} color="primary" autoFocus>
          Agree
        </Button> */}
        {!!dialogActions && dialogActions}
      </DialogActions>
    </Dialog>
  )
}

export default CustomSnackbar
